function addToSessionStore(params) {
 //console.log("addToSessionStore : ", params);
  if(params.item) {
    let items = window.botStore[params.item] || window.devStore[params.item];
    if(items) {
      sessionStorage.setItem(params.item, JSON.stringify(items));
    } else {
      sessionStorage.removeItem(params.item);
    }
  }
}

function delFromSessionStore(params) {
  if(params.item) {
    sessionStorage.removeItem(params.item);
  }
}

function getFromSessionStore(params, callback) {
  if(params.item) {
    let items = sessionStorage.getItem(params.item);
    if(items) {
      callback(null, JSON.parse(items));
    } else {
      callback(null, null);
    }
  } else {
    callback(null, null);
  }
}

export {
  addToSessionStore,
  getFromSessionStore,
  delFromSessionStore
}
